import { i18n } from 'src/boot/i18n';
import { isObjectEmtpy } from 'src/utils/general';
import { useDocAttributesStore } from 'src/store/main';
import { isDocTypeInvoice, CONSTANTS } from 'src/constants';
import { notify } from 'src/components/notifications/notify';

export default {
  methods: {
    poActionDisableStatusList() {
      return ['error', 'running', 'restart_in_progress'];
    },

    async isPoSettingActivate(doc_type: string) {
      const doc_attribute_store = useDocAttributesStore();
      await doc_attribute_store.fetchAttributes(doc_type);
      const { model } = doc_attribute_store;

      const po_activate = model[CONSTANTS.is_po_active];
      if (po_activate === undefined || po_activate == '') {
        return false;
      }
      return po_activate === 'true' || po_activate === true ? true : false;
    },

    async getPOUrl (doc_type:string) {

      const doc_attribute_store = useDocAttributesStore();
      await doc_attribute_store.getDocTypeAllSettings();

      const isServerSideMatching = doc_attribute_store.getSettingsByDocTypeAndSettingKey(doc_type, CONSTANTS.PO_MATCH_SERVER_SIDE)

      return isServerSideMatching ? '/po-matching/' : '/po-matching-v3/';
    },

    isPoIconAllowed (status: string, table_version : any, invoice_sub_type = null) {
      if (invoice_sub_type == 'Cost Invoice') {
        return false;
      }

      if (table_version === null) {
        return false;
      }
      if (this.poActionDisableStatusList().includes(status)) {
        return false;
      }

      return true;
    },
    getMandatoryColumnsForPo(doc_type: string) {
      const mandatoryColums = ['quantity', 'item_number', 'net_amount'];
      if (doc_type != 'DELIVERY_NOTE') {
        mandatoryColums.push('unit_price');
      }
      return mandatoryColums;
    },
    hasLineItems(tables: any): boolean {
      return !(
        !tables ||
        tables.length == 0 ||
        isObjectEmtpy(tables) ||
        (!tables[0] && tables[0].rows[0])
      );
    },
    getMissingMandatoryColumns(tables: any, doc_type: string): string[] {
      // validate table columns if it contains Item Number, Unit Price, Quantity, Net amount
      const mandatoryColums = this.getMandatoryColumnsForPo(doc_type);

      if (mandatoryColums.length == 0) {
        return mandatoryColums;
      }

      const tableRows = tables[0].rows[0];
      Array.from(tableRows.columns).forEach((column: any) => {
        const index = mandatoryColums.indexOf(column.name.toLowerCase());
        if (index > -1) {
          mandatoryColums.splice(index, 1);
        }
      });

      return mandatoryColums;
    },
    validateLineItemTable(tables: any, doc_type: string): boolean {
      if (!this.hasLineItems(tables)) {
        notify.warning(
          i18n.t('po_restrict_message_not_items'),
        );
        return false;
      }

      if (this.getMissingMandatoryColumns(tables, doc_type).length > 0) {
        notify.warning(
          i18n.t('MISSING_MANDATORY_COLUMNS'),
        );
        return false;
      }

      return true;
    },
    cleanItemNumber(itemNumber: string) {
      if(!itemNumber) { return ''; }
      const characters_to_remove = [' ', '`', '*', '_','{', '}', '[', ']','(', ')', '>', '#','+', '-', '.', ',','!', '$', '\''];
      for(const char of characters_to_remove) {
        itemNumber = itemNumber.split(char).join('');
      }

      return itemNumber;
    },
  },
};
